import { useMemo } from 'react'
import { useUserPaymentsContextValue } from 'pages/UserPayments/context/UserPaymentsProvider'
import { UserPayment } from 'api/payments'
import { ColumnDef } from '@tanstack/react-table'
import {
  ActionsColumn,
  IDColumn,
  UserColumn,
  AmountColumn,
  StatusColumn,
  TypeColumn,
  EventTypeColumn,
  selectableColumns,
} from './columns'

export const useSelectedColumns = (): ColumnDef<UserPayment>[] => {
  const {
    state: { selectedColumnsFilters },
  } = useUserPaymentsContextValue()

  const columnsToDisplay = useMemo(() => {
    const filteredColumns = selectableColumns
      .filter((column) => selectedColumnsFilters.includes(column.id))
      .map((column) => column.columnDef)

    return [
      IDColumn,
      ...(selectedColumnsFilters.includes('user') ? [UserColumn] : []), // Ugly way to define the ordering of user column here
      AmountColumn,
      StatusColumn,
      TypeColumn,
      EventTypeColumn,
      ...filteredColumns.filter((column) => column !== UserColumn),
      ActionsColumn,
    ]
  }, [selectedColumnsFilters])

  return columnsToDisplay
}
